import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';
import { capitalizeFirstLetter } from '../pages/attendee/detail/components/utils';
import i18n from 'i18next/index';

export default class AttendeeComment extends BaseAPIModel {
    fields() {
        return {
            uuid: { primaryKey: true, readOnly: true },
            name: {}
        };
    }

    // TODO: handle limit/offset rules
    static listUrl({ organizationId, attendeeId, eventId }) {
        if (!organizationId || !attendeeId) {
            throw new ArgumentError(`[Model][AttendeeComment][getAll] organizationId and attendeeId are mandatory`);
        }

        if (!eventId) {
            return `/ticket/organizations/${organizationId}/attendees/${attendeeId}/comments`;
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/attendees/${attendeeId}/comments`;
    }

    get resolved_user_name() {
        if (this.object.user.last_name || this.object.user.first_name) {
            return `${capitalizeFirstLetter(this.object.user.first_name)} ${capitalizeFirstLetter(this.object.user.last_name)}`;
        }
        return i18n.t('ticket.manager.nonNominative');
    }
}
